<template>
  <div>
    <b-link v-b-modal="modalId">
      Passport integratsiyasi
    </b-link>
    <b-modal
      :id="modalId"
      :title="$t('Show passport data')"
      hide-footer
      size="lg"
    >
      <table class="table">
        <tr
          v-for="field in fields"
          :key="field.key"
        >
          <th> {{ $t(field.label) }}</th>
          <td>
            {{ user && user[field.key] ? modifier(field.key,user[field.key]): "N/A" }}
          </td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import { VBModal, BLink } from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'

export default {
  name: 'ShowPassportModalComponent',
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BLink,
  },
  props: {
    user: {
      type: Object,
    },
    modalId: {
      type: String,
      default: () => 'show-passport-data',
    },
  },
  methods: {
    modifier(key, value) {
      if (key === 'gd') {
        return this.$t(this.getUserGd(Number(value)))
      }
      if (key === 'user_type') {
        return this.$t(this.getUserType(value))
      }
      return value
    },
    getUserType(type) {
      return this.$store.getters['staticModule/getUserType'](type).name[`${this.$i18n.locale}`]
    },
    getUserGd(type) {
      return this.$store.getters['staticModule/getUserGd'](type).name[`${this.$i18n.locale}`]
    },
  },
  setup() {
    const fields = [
      { key: 'full_name', label: 'Full name' },
      { key: 'birth_date', label: 'Birthday' },
      { key: 'birth_place', label: 'Birth place' },
      { key: 'birth_region', label: 'Birth region' },
      { key: 'ctzn', label: 'Citizenship' },
      { key: 'gd', label: 'Gender' },
      { key: 'mob_phone_no', label: 'Mobile phone' },
      { key: 'natn', label: 'Nationality' },
      { key: 'per_adr', label: 'Permanent address' },
      { key: 'pin', label: 'PNFL' },
      { key: 'pport_expr_date', label: 'Validity of the passport' },
      { key: 'pport_issue_date', label: 'Date of passport issuance' },
      { key: 'pport_issue_place', label: 'Who issued the passport' },
      { key: 'pport_no', label: 'Passport series and number' },
      { key: 'user_type', label: 'User Type' },
    ]
    return {
      fields,
    }
  },
}
</script>

<style scoped>

</style>
